import { ConfigContext } from '@/components/ConfigProvider/configProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/index.module.less';

export default function DocBtn() {
  const { lang, config } = useContext(ConfigContext);
  const { t } = useTranslation();

  if (!config?.doc) return null;

  return (
    // <Tooltip position="bottom" trigger="hover" content={lang === ZH_CN ? '用户手册' : 'Document'}>
    <span
      onClick={() => window.open(config?.doc, '_blank')}
      className={`${styles['navbar-right-btn']}`}
    >
      {t('common:userDoc')} {/* <IconQuestionCircle /> */}
    </span>
    // </Tooltip>
  );
}
